import React from "react";
import {
    Datagrid, DateField,
    List,
    TextField,
    TextInput,
    SelectInput,
    Filter, ReferenceField, SimpleShowLayout,
} from "react-admin";
import ShowView from "../../components/ShowView";
import {AdminLogHistoryFilterActionTypes, AdminLogHistoryFilterLogTypes} from "./adminLogHistoryConstant";

const AdminLogHistoryFilter = (props) => (
  <Filter {...props}>
    <TextInput label="شناسه" source="objectId"/>
    <TextInput label="شناسه کاربر" source="userId"/>
    <SelectInput
      label="عملیات"
      choices={AdminLogHistoryFilterActionTypes}
      optionText={"name"}
      optionValue={"value"}
      source={"action"}
      alwaysOn
    />
      <SelectInput
          label="نوع"
          choices={AdminLogHistoryFilterLogTypes}
          optionText={"name"}
          optionValue={"value"}
          source={"logType"}
          alwaysOn
      />
  </Filter>
);


export const AdminLogHistoryList = (props) => (
  <List {...props} filters={<AdminLogHistoryFilter/>} >
    <Datagrid rowClick={"show"}>
      <TextField source="objectId"/>
        <ReferenceField link="show" label="کاربر" source="userId" reference="user" >
            <TextField source="name"/>
        </ReferenceField>
        <TextField source="phoneNumber"/>
        <TextField source="logType"/>
        <TextField source="action"/>
        <DateField showTime={true} locales={"fa-IR"} source="createdAt"/>
    </Datagrid>
  </List>
);

export const AdminLogHistoryShow = (props) => (
    <ShowView {...props} noDel={true} noEdit={true}>
    <SimpleShowLayout>
        <TextField source="objectId"/>
        <ReferenceField link="show" label="کاربر" source="userId" reference="user" >
            <TextField source="name"/>
        </ReferenceField>
        <TextField source="phoneNumber"/>
        <TextField source="logType"/>
        <TextField source="action"/>
        <TextField source="previousData"/>
        <TextField source="nextData"/>
        <DateField  showTime={true} locales={"fa-IR"} source="createdAt"/>
    </SimpleShowLayout>
    </ShowView>
);
